import React, { useReducer } from "react";
const initialState = {
  isMenuOpen: false,
  loader: false,
};

export const UIContext = React.createContext(initialState);

UIContext.displayName = "UIContext";

function uiReducer(state, action) {
  switch (action.type) {
    case "SET_MENU_OPEN": {
      return {
        ...state,
        isMenuOpen: action?.value,
      };
    }
    case "SET_LOADER": {
      return {
        ...state,
        // loader: action?.value,
      };
    }
  }
}

export const UIProvider = (props) => {
  const [state, dispatch] = useReducer(uiReducer, initialState);

  const value = React.useMemo(() => {
    const setIsMenuOpen = (value) =>
      dispatch({ type: "SET_MENU_OPEN", value: value });
    // const setLoader = (value) => dispatch({ type: "SET_LOADER", value: value });

    return {
      ...state,
      setIsMenuOpen,
      // setLoader,
    };
  }, [state]);

  return <UIContext.Provider value={value} {...props} />;
};

export const useUI = () => {
  const context = React.useContext(UIContext);
  if (context === undefined) {
    throw new Error(`useUI must be used within a UIProvider`);
  }
  return context;
};

export const ManagedUIContext = ({ children }) => (
  <>
    <UIProvider>{children}</UIProvider>
  </>
);
